<template>
  <!--  <router-view v-slot="{ Component }">
    <transition name="fade">
      <component :is="Component" />
    </transition>
  </router-view> -->
  <router-view> </router-view>
  <ModalWindow v-if="show" @close="show = false">
    <template #header>Ошибка</template>{{ message }}</ModalWindow
  >
</template>

<script>
import { ref } from "vue";
import eventBus from "./event-bus";
import ModalWindow from "@/components/ModalWindow";

export default {
  name: "App",
  components: { ModalWindow },
  setup() {
    const show = ref(false);
    const message = ref("");
    eventBus.on("error", (error) => {
      show.value = true;
      message.value = error.message;
    });

    return { show, message };
  },
};
</script>

<style lang="css">
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
